export const getFetchUrlWithId = (
  endpoint: string,
  query?: string,
  id?: string
) => {
  // query is undefined if it is not yet updated for current table
  if (query === undefined || !id) return null;
  return query ? `${endpoint}?${query}` : endpoint;
};
